export default __webpack_public_path__ + "static/media/arrow-down.cc14feef.svg";